import React from 'react';
import { Stack } from 'expo-router';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export default function RootLayout() {
  return <Stack initialRouteName="(tabs)" screenOptions={SCREEN_OPTIONS} />;
}

// ─── Constants ───────────────────────────────────────────────────────────────

const SCREEN_OPTIONS = {
  title: 'sweetgreen',
  headerShown: false,
  headerTitleAlign: 'center' as const,
  headerStyle: { backgroundColor: theme.colors.APP_BACKGROUND },
};
